import { LayoutGrid, Rows3 } from "@/components/ui/icons";

import { IconSegments } from "@/components/ui/IconSegments";
import type { BrowseLayout } from "@/hooks/usePublicBrowseView";

/**
 * The customer browse page's Grid/List switch (#341), on the shared `IconSegments` inventory's
 * toolbar uses, so the two read as one control. The layout is the customer's own choice, never the
 * vendor's.
 */
export function BrowseViewToggle({
  layout,
  onChange,
}: {
  layout: BrowseLayout;
  onChange: (l: BrowseLayout) => void;
}) {
  return (
    <IconSegments
      testID="browse-view-toggle"
      label="Layout"
      value={layout}
      onChange={onChange}
      segments={[
        { value: "list", label: "List view", icon: Rows3, testID: "browse-view-toggle-list" },
        { value: "grid", label: "Grid view", icon: LayoutGrid, testID: "browse-view-toggle-grid" },
      ]}
    />
  );
}
